import { Box, Center, CircularProgress, Collapse, Text } from '@chakra-ui/react'
import { colors } from '@hb/shared'
export const LoadingOtherMessages = ({
  loading,
  range,
}: {
  loading: boolean
  range: 'earlier' | 'later'
}) => (
  <Collapse unmountOnExit in={loading} style={{ width: '100%' }}>
    <Center gap={2} alignItems="center" w="100%" p={2}>
      <CircularProgress size={5} color={colors.green.hex} isIndeterminate={loading} />
      <Text size="sm" color="gray.500" fontStyle="italic">
        Loading {range === 'earlier' ? 'older' : 'newer'} messages...
      </Text>
    </Center>
  </Collapse>
)

export const HasOtherMessages = ({
  hasMore,
  loadingMore,
  range,
}: {
  hasMore: boolean
  loadingMore: boolean
  range: 'earlier' | 'later'
}) => (
  <Collapse unmountOnExit in={hasMore && !loadingMore} style={{ width: '100%' }}>
    <Center pt={range === 'earlier' ? 2 : 0} pb={range === 'later' ? 2 : 0} w="100%">
      <Text size="sm" color="gray.500" fontStyle="italic">
        Has {range === 'earlier' ? 'earlier' : 'later'} messages
      </Text>
    </Center>
  </Collapse>
)

export const NoOtherMessages = ({
  hasMore,
  loadingMore,
  range,
}: {
  hasMore: boolean
  loadingMore: boolean
  range: 'earlier' | 'later'
}) => (
  <Collapse unmountOnExit in={!hasMore && !loadingMore} style={{ width: '100%' }}>
    <Center w="100%">
      <Text size="sm" color="gray.500" pt={1} fontStyle="italic">
        {range === 'earlier' ? 'Beginning' : 'End'} of thread
      </Text>
    </Center>
  </Collapse>
)

export const OtherMessagesStatus = ({
  hasMore,
  loadingMore,
  range,
}: {
  hasMore: boolean
  loadingMore: boolean
  range: 'earlier' | 'later'
}) => (
  <Box w="100%">
    <LoadingOtherMessages loading={loadingMore} range={range} />
    {/* <HasOtherMessages hasMore={hasMore} loadingMore={loadingMore} range={range} /> */}
    {range === 'earlier' ? (
      <NoOtherMessages hasMore={hasMore} loadingMore={loadingMore} range={range} />
    ) : null}
  </Box>
)
